import qs from 'qs';

const sOptions = {
  encodeValuesOnly: true,
  skipNulls: true,
  arrayFormat: 'comma',
};

const pOtions = { ignoreQueryPrefix: true };

const sanitize = (obj) =>
  JSON.parse(
    JSON.stringify(obj, (k, v) => (v === null || v === undefined ? '' : v)),
  );
export const qsStringify = (state, options = sOptions) =>
  qs.stringify(sanitize(state), options);
export const qsParse = (url) => qs.parse(url, pOtions);

export const getCsvUrl = ({ url, params }) =>
  `${url}${qsStringify(params, { ...sOptions, addQueryPrefix: true })}`;
